module.exports = __webpack_public_path__ + "static/media/CHARM.60e8e7cd.svg";